import { commonTranslationKeys, FieldControllerProps, FormContextValues } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

import { prefixFieldName } from './common.utils';

type FlatFieldProps = Pick<FormContextValues, 'register'> &
   Pick<FieldControllerProps<'flat', string | null>, 'name' | 'required'> &
   ClassNameProp & {
      readonly prefix?: string;
   };

export const FlatField = (props: FlatFieldProps): JSX.Element => {
   const { name, prefix, register } = props;
   const fieldName = prefixFieldName(name, prefix);
   return (
      <TextInput
         controller={register(fieldName, {
            maxLength: 10,
         })}
         label={commonTranslationKeys.addressData.apartmentNumberAbbreviation}
         testId={fieldName}
      />
   );
};
